// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TemplateSelector_wrapper__bTSWF"};